/**
 * PayrollDashboardPage - Payroll run management dashboard
 *
 * Surfaces the PayrollDashboard from @ferp/workflow-forms for payroll administrators.
 * Provides payroll run management, 11-state workflow visualization, and run history.
 *
 * Route: /payroll/dashboard
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconCash } from '@tabler/icons-react';

import { PayrollDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function PayrollDashboardPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="green">
            <IconCash size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Payroll Dashboard</Title>
            <Text size="sm" c="dimmed">
              Payroll run management, workflow status, and run history
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <PayrollDashboard />
    </Container>
  );
}

export default PayrollDashboardPage;
